import React from 'react';
import {
  Item,
  Text,
  SubText,
  Content,
  Ubigeo,
  RadioInputWrapper
} from './styled';

interface Props {
  text: string;
  pos?: number;
  active?: boolean;
  subtext?: string;
  ubigeo?: string;
  handleChange?: Function;
  colorActive?: string;
  checked?: boolean;
  innerRef?: any;
}

export const Option: React.FC<Props> = ({
  text,
  pos,
  active,
  subtext,
  ubigeo,
  handleChange,
  colorActive,
  checked,
  innerRef
}) => (
  <Item
    active={active}
    pos={pos}
    data-index={pos}
    ref={innerRef}
    tabIndex="-1">
    <RadioInputWrapper
      name="operation"
      value={pos}
      handleChange={e => handleChange(e)}
      colorActive={colorActive}
      contentLeft
      checked={checked}
    >
      <Content>
        <Text>{text}{ubigeo && <Ubigeo>, {ubigeo}</Ubigeo>}</Text>
        {subtext && <SubText>{subtext}</SubText>}
      </Content>
    </RadioInputWrapper>
  </Item>
);
